export const form = {
  template_id: 0, // 默认模板为0
  line_id: undefined, // 发布平台
  typeid: undefined, // 文章分类
  title: '', // 标题
  title2: '', // 小标题
  // recommended: 1, // 是否推荐
  iscommend: 0, // 是否推荐
  istop: 0, // 是否置顶
  is_rand: 1, // 是否随机阅读
  publisher_id: undefined, // 发布者id
  author: '', // 作者
  label_ids: [], // 标签ID
  description: '', // 摘要
  keywords: '', // 关键词
  smeta: '', // 文章图片
  thumbimage: '', // 缩略图
  banner: '', // banner地址
  app_picture_one: '',
  app_picture_cut_one: '',
  app_picture_two: '',
  app_picture_cut_two: '',
  app_picture_three: '',
  app_picture_cut_three: '',
  content: '' // 文章内容
}

export const rules = {
  line_id: [
    { required: true, message: '请选择发布平台', trigger: 'change' }
  ],
  typeid: [
    { required: true, message: '请选择文章分类', trigger: 'change' }
  ],
  title: [
    { required: true, message: '请输入标题', trigger: 'change' }
  ],
  title2: [
    { required: true, message: '请输入小标题', trigger: 'change' }
  ],
  recommended: [
    { required: true, message: '请选择是否推荐', trigger: 'change' }
  ],
  publisher_id: [
    { required: true, message: '请选择发布者', trigger: 'change' }
  ],
  istop: [
    { required: true, message: '请选择是否置顶', trigger: 'change' }
  ],
  is_rand: [
    { required: true, message: '请选择是否随机阅读数', trigger: 'change' }
  ],
  description: [
    { required: true, message: '请填写摘要', trigger: 'change' }
  ],
  keywords: [
    { required: true, message: '请填写关键词', trigger: 'change' }
  ],
  label_ids: [
    { required: true, message: '请选择标签', trigger: 'change' }
  ],
  author: [
    { required: true, message: '请填写作者', trigger: 'change' }
  ],
  content: [
    { required: true, message: '请填写内容', trigger: 'change' }
  ]
}
